import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';


@Injectable({ providedIn: 'root' })
export class SettingsService {

  constructor(
    private httpClient: HttpClient
  ) {
  }

  getWorkstationParams(): any {
    return this.httpClient.get("assets/config/cargoeye.yaml", {
      observe: 'body',
      responseType: 'text'   // tells HttpClient to parse it as text, not as JSON
    }).pipe(
      map(yamlString => this.parseYamlStringToObj(yamlString))
    );
  }

  updateScanningZone(x: number, y: number, z: number): any {
    return this.httpClient.put(
      `${environment.SYSTEMINFO_API_ENDPOINT}/scanning-zone`,
      { x, y, z }
    );
  }

  gettRefereceObjConf(): any {
    return this.httpClient.get("assets/config/computer/reference_object_conf.json"); 
  }

  getBoardSetting(): any {
    return this.httpClient.get("assets/config/computer/board_setting.json"); 
  }

  parseYamlStringToObj(yamlFileString): any {
    let yamlObj:any = {};
    let lines: string[] = (yamlFileString as unknown as string).toString().split("\n");  // create array where each YAML line is one entry
    let char_to_check=0;
    if (lines[0] === "/**:"){
      // console.log("using ros2 config")
      char_to_check=4; // use ros2 config, checks 5th character
      lines = lines.slice(2); // skip /**: and  ros__parameters: lines
    }
    lines.forEach((line: string) => {
      if (line.charAt(char_to_check) === "/"){ 
        let delimiter = line.indexOf(':'); 
        let final_value: any;
        let key = line.slice(char_to_check, delimiter);  
        let value = line.slice(delimiter+1); 
        let relavantKeys=[
          "/cargoeye/system_name", "/cargoeye/cameras",
          "/cargoeye/scanning_zone/size_x",
          "/cargoeye/scanning_zone/size_y",
          "/cargoeye/scanning_zone/size_z"
        ]
        if (relavantKeys.includes(key)){
          // clean value
          value = value.replace(/\s/g, ''); // remove white spaces
          if (value.includes("#")){         // remove back comments
            let commentdelimiter = value.indexOf('#');
            value=value.slice(0,commentdelimiter);
          }
          // check for string
          if (value.charAt(0)==="\"" || value.charAt(0)==="\'" ){
            final_value =value.slice(1,-1);
          }
          // check for array
          else if (value.charAt(0)==="["){
            let temparr = [];
            final_value=[];
            value =value.slice(1,-1);
            temparr=value.split(",");
            temparr.forEach((elem:string) =>{
              if (parseFloat(elem)){
                final_value.push(parseFloat(elem));
              }
              else if (parseInt(elem)){
                final_value.push(parseInt(elem));
              }
              else{
                final_value.push(elem.slice(1,-1));  // remove the " "
              }
            })
          }
          // check for number (float or int)
          else if (!isNaN(parseFloat(value))) {
            final_value = parseFloat(value);
          }
          yamlObj[key]=final_value;
        }
      }
    });
    return yamlObj;
  }
}

